export const multipleSessionsLabels = {
  multiSessionTitle: "Looks like you're viewing your cart in 2 different devices.",
  continueOption: 'Continue with this device.',
  exitOptionMobile: 'Exit the flow on this device and continue with the flow on your mobile.',
  exitOptionDesktop: 'Exit the flow on this device and continue with the flow on your desktop browser.',
  continueCta: 'Continue',
};
